export default __webpack_public_path__ + "static/media/logo_firebase.36a49b18.svg";